export const customerTemplate ={
	bio: '',
	birth_date: new Date(),
	cellphone: '',
	cpf: '',
	is_seller: false,
	profession: '',
	user: {
		email: '',
		first_name: '',
		last_name: '',
		password: '',
		username: ''
	},
	who_indicated: '',
	address: {
		city: ".",
		complement: ".",
		country: ".",
		neighborhood: ".",
		number: '.',
		postcode: ".",
		state: ".",
		street_address: ".",
	}
}

export const customerColumns = [
	{
		Header: 'ID',
		accessor: 'id'
	},{
		Header: 'Nome',
		accessor: 'user.first_name'
	},{
		Header: 'Profissao',
		accessor: 'profession'
	},{
		Header: 'Email',
		accessor: 'user.email'
	},{
		Header: 'Tipo',
		accessor: 'is_seller',
		Cell: ({ cell: { value } }) => {
			return (
				value ? "Profissional": "Consumidor" 
			);
		  }
	},{
		Header: 'Inicação',
		accessor: 'who_indicated'
	},
]
